import styled from 'styled-components';

import { colors } from '../../constants';

interface IProps {
    passed: boolean;
    active: boolean;
    backgroundGrey?: boolean;
}

export const Node = styled.div<IProps>`
    border-radius: 50%;
    background: ${(props) =>
        props.passed
            ? colors.greenDark
            : props.backgroundGrey
            ? colors.greyDark
            : colors.white};
    width: ${(props) => (props.active ? '12px' : '8px')};
    height: ${(props) => (props.active ? '12px' : '8px')};
    z-index: 2;
`;
